<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 64 64"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero">
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#1A476F"
                  d="M0 49.947L6.524 57.778 7.111 57.064 7.111 6.979 6.524 6.222 0 14.05 0 49.947"
                  transform="translate(-974 -491) translate(350 416) translate(571 43) translate(53 32) translate(4)"
                />
                <path
                  fill="#1F5B98"
                  d="M6 57.648L19.432 64 19.991 63.15 20 0.666 19.442 0 6 6.331 6 57.648"
                  transform="translate(-974 -491) translate(350 416) translate(571 43) translate(53 32) translate(4)"
                />
                <path
                  fill="#2D72B8"
                  d="M56 13.895L48.805 6 48 6.239 48.16 57.355 48.805 58 56 50.103 56 13.895"
                  transform="translate(-974 -491) translate(350 416) translate(571 43) translate(53 32) translate(4)"
                />
                <path
                  fill="#5294CF"
                  d="M36.641 64L50 57.648 50 6.331 36.632 0 36 0.813 36.009 63.076 36.641 64"
                  transform="translate(-974 -491) translate(350 416) translate(571 43) translate(53 32) translate(4)"
                />
                <path
                  fill="#2D72B8"
                  d="M20 0L36 0 36 64 20 64z"
                  transform="translate(-974 -491) translate(350 416) translate(571 43) translate(53 32) translate(4)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'AmazonDBLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
